import React, { useState, useEffect } from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { HelpCircle } from 'lucide-react';
import { api, fallbackData } from '../data/api';

const FAQSection = () => {
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFaqs = async () => {
      try {
        const data = await api.getFaqs();
        if (data && data.length > 0) {
          setFaqs(data);
        } else {
          setFaqs(fallbackData.faqs);
        }
      } catch (error) {
        setFaqs(fallbackData.faqs);
      } finally {
        setLoading(false);
      }
    };
    fetchFaqs();
  }, []);

  return (
    <section id="faq" className="py-20 md:py-28 bg-zinc-900 relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-amber-500/5 rounded-full blur-3xl"></div>
      </div>

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <span className="inline-block text-amber-400 text-sm font-semibold tracking-wider uppercase mb-4">
            Sıkça Sorulan Sorular
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6">
            Merak <span className="text-amber-400">Edilenler</span>
          </h2>
          <p className="text-zinc-400 text-lg max-w-2xl mx-auto">
            Denizli taksi hizmeti hakkında en çok sorulan sorular ve cevapları.
          </p>
        </div>

        {/* FAQ Accordion */}
        {loading ? (
          <div className="bg-zinc-800/30 rounded-2xl border border-zinc-700/50 overflow-hidden p-6">
            {[...Array(5)].map((_, i) => (
              <div key={i} className="border-b border-zinc-700/50 last:border-0 py-4 animate-pulse">
                <div className="h-6 bg-zinc-700 rounded w-3/4"></div>
              </div>
            ))}
          </div>
        ) : (
          <div className="bg-zinc-800/30 backdrop-blur-sm rounded-2xl border border-zinc-700/50 overflow-hidden">
            <Accordion type="single" collapsible className="w-full">
              {faqs.map((faq, index) => (
                <AccordionItem 
                  key={faq.id || index} 
                  value={`item-${index}`}
                  className="border-b border-zinc-700/50 last:border-0"
                >
                  <AccordionTrigger className="px-6 py-5 text-left hover:no-underline hover:bg-zinc-800/50 transition-colors group">
                    <div className="flex items-center gap-3">
                      <div className="w-8 h-8 bg-amber-500/20 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-amber-500/30 transition-colors">
                        <HelpCircle className="w-4 h-4 text-amber-400" />
                      </div>
                      <span className="text-white font-medium text-lg">{faq.question}</span>
                    </div>
                  </AccordionTrigger>
                  <AccordionContent className="px-6 pb-5 pt-0">
                    <div className="pl-11 text-zinc-400 leading-relaxed">
                      {faq.answer}
                    </div>
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        )}
      </div>
    </section>
  );
};

export default FAQSection;
